/******************************************
 *  Author : Suraj Sharma
 *  Created On : Tue Apr 13 2021
 *  File : index.jsx
 *******************************************/
 import DynamicPage from './[pageName]';

 export default DynamicPage;
 